module.exports = __webpack_public_path__ + "static/media/main25.f3a3d368.png";